import React from 'react';
import { connect } from 'react-redux';
import Carousel from 'nuka-carousel';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import trackGa from '../utils/trackEvent';
import Review from './Review';

const controlPositionsMap = {
	'top-left': 'renderTopLeftControls',
	'top-center': 'renderTopCenterControls',
	'top-right': 'renderTopRightControls',
	'center-left': 'renderCenterLeftControls',
	'center-center': 'renderCenterCenterControls',
	'center-right': 'renderCenterRightControls',
	'bottom-left': 'renderBottomLeftControls',
	'bottom-center': 'renderBottomCenterControls',
	'bottom-right': 'renderBottomRightControls'
};
export class SliderComponent extends React.Component {
	constructor(props) {
		super(props);
		this.sliderRef = React.createRef();
		this.state = {
			view: 'desktop',
			itemsPerSlide: 3,
			currentSlide: 1
		};
	}

	componentDidMount() {
		if (this.sliderRef.current) {
			this.findView(this.sliderRef.current.getBoundingClientRect().width);
			if (typeof ResizeObserver !== 'undefined') {
				const resizeObserver = new ResizeObserver((entries) => {
					this.findView(entries[0].contentRect.width);
				});
				resizeObserver.observe(this.sliderRef.current);
			}
		}
		const pagingDotsControl = document.querySelector(
			'.slider-control-bottomcenter'
		);
		if (pagingDotsControl) {
			pagingDotsControl.addEventListener('click', () =>
				this.pagingDotsControlHandler()
			);
		}
	}

	getCarouselProps(renderPreviousButton, renderNextButton) {
		const { nextSlideControlPosition, previousSlideControlPosition } =
			this.props;
		const previousRendererKey =
			controlPositionsMap[previousSlideControlPosition];
		const nextRendererKey = controlPositionsMap[nextSlideControlPosition];
		const { itemsPerSlide } = this.state;
		const carouselProps = {
			afterSlide: (index) =>
				this.setState({
					currentSlide: Math.floor(index / itemsPerSlide + 1)
				}),
			slideIndex: 0,
			wrapAround: true,
			speed: 700,
			transitionMode: 'scroll',
			easing: 'easePolyInOut',
			[previousRendererKey]: renderPreviousButton,
			[nextRendererKey]: renderNextButton
		};
		// if renderCenterLeftControls is not used we should set it as null from prevent the default controls to appear
		if (
			previousRendererKey !== 'renderCenterLeftControls' &&
			nextRendererKey !== 'renderCenterLeftControls'
		) {
			carouselProps.renderCenterLeftControls = null;
		}
		if (
			previousRendererKey !== 'renderCenterRightControls' &&
			nextRendererKey !== 'renderCenterRightControls'
		) {
			carouselProps.renderCenterRightControls = null;
		}
		return carouselProps;
	}

	findView(width) {
		let view = 'desktop';
		let itemsPerSlide = 3;
		if (width < 650) {
			view = 'mobile';
			itemsPerSlide = 1;
		} else if (width < 900) {
			view = 'tablet';
			itemsPerSlide = 2;
		}
		if (view !== this.state.view) {
			this.setState({ view, itemsPerSlide });
		}
	}

	pagingDotsControlHandler() {
		const { reviewData, windowId } = this.props;

		const additionalData = {
			totalItems: Math.ceil(reviewData.length / this.state.itemsPerSlide),
			currentItem: this.state.currentSlide,
			label: 'dots'
		};
		trackGa(
			windowId,
			'Carousel Paging dots',
			'Select Paging dot',
			additionalData
		);
	}

	render() {
		const {
			reviewData,
			singleSource,
			windowId,
			reviewTruncationLength,
			labels,
			arrowStyle,
			fontSize,
			reviewDateFontSize,
			ratingStarFullFillColor
		} = this.props;

		const arrowClick = (fn, direction, slideCount, currentSlide) => {
			const additionalData = {
				totalItems: Math.ceil(slideCount / this.state.itemsPerSlide),
				currentItem: currentSlide / this.state.itemsPerSlide + 1,
				label: direction
			};
			trackGa(
				windowId,
				`Carousel ${direction} Button`,
				'Move to next set of reviews',
				additionalData
			);
			fn();
		};
		const renderPreviousButton = ({
			previousSlide,
			slideCount,
			currentSlide
		}) => (
			<button
				className="btn-unstyled"
				type="button"
				aria-label="previous"
				onClick={() =>
					arrowClick(
						previousSlide,
						'Previous',
						slideCount,
						currentSlide
					)
				}
			>
				<i
					className={`ddc-icon ddc-icon-${arrowStyle}-left ddc-icon-size-xxlarge`}
					aria-hidden="true"
				/>
			</button>
		);
		const renderNextButton = ({ nextSlide, slideCount, currentSlide }) => (
			<button
				className="btn-unstyled"
				type="button"
				aria-label="next"
				onClick={() =>
					arrowClick(nextSlide, 'Next', slideCount, currentSlide)
				}
			>
				<i
					className={`ddc-icon ddc-icon-${arrowStyle}-right ddc-icon-size-xxlarge`}
					aria-hidden="true"
				/>
			</button>
		);

		const carouselProps = this.getCarouselProps(
			renderPreviousButton,
			renderNextButton
		);
		const ResponsiveSettings = {
			desktop: {
				...carouselProps,
				slidesToShow: this.state.itemsPerSlide,
				slidesToScroll: this.state.itemsPerSlide,
				...(reviewData.length <= this.state.itemsPerSlide && {
					renderCenterRightControls: null,
					renderCenterLeftControls: null,
					renderBottomCenterControls: null,
					dragging: false
				})
			},
			tablet: {
				...carouselProps,
				slidesToShow: this.state.itemsPerSlide,
				slidesToScroll: this.state.itemsPerSlide,
				...(reviewData.length <= this.state.itemsPerSlide && {
					renderCenterRightControls: null,
					renderCenterLeftControls: null,
					renderBottomCenterControls: null,
					dragging: false
				})
			},
			mobile: {
				...carouselProps,
				slidesToShow: this.state.itemsPerSlide,
				slidesToScroll: this.state.itemsPerSlide,
				...(reviewData.length <= this.state.itemsPerSlide && {
					renderCenterRightControls: null,
					renderCenterLeftControls: null,
					renderBottomCenterControls: null,
					dragging: false
				})
			}
		};
		if (reviewData.length > 0) {
			return (
				<div className="w-100 mt-4 mt-sm-10" ref={this.sliderRef}>
					<Carousel
						{...ResponsiveSettings[this.state.view]}
						className="px-8 pb-8"
					>
						{reviewData.map((review) => (
							<Review
								key={review.id}
								review={review}
								singleSource={singleSource}
								windowId={windowId}
								reviewTruncationLength={reviewTruncationLength}
								labels={labels}
								fontSize={fontSize}
								reviewDateFontSize={reviewDateFontSize}
								ratingStarFullFillColor={
									ratingStarFullFillColor
								}
							/>
						))}
					</Carousel>
				</div>
			);
		} else {
			return (
				<Alert bsStyle="info" className="m-2 m-sm-10">
					{labels.get('NO_REVIEWS_ALERT_MESSAGE')}
				</Alert>
			);
		}
	}
}

SliderComponent.propTypes = {
	reviewData: PropTypes.arrayOf(PropTypes.shape),
	singleSource: PropTypes.bool.isRequired,
	windowId: PropTypes.string.isRequired,
	reviewTruncationLength: PropTypes.number.isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func
	}).isRequired,
	arrowStyle: PropTypes.string.isRequired,
	fontSize: PropTypes.string,
	reviewDateFontSize: PropTypes.string,
	nextSlideControlPosition: PropTypes.string,
	previousSlideControlPosition: PropTypes.string,
	ratingStarFullFillColor: PropTypes.string
};

SliderComponent.defaultProps = {
	reviewData: [],
	fontSize: '',
	reviewDateFontSize: ''
};

const mapStateToProps = (state) => {
	return {
		reviewData: state.reviewData,
		windowId: state.requestData.windowId
	};
};

const mapDispatchToProps = (_dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SliderComponent);
